import { useEffect, useMemo, useRef, useState } from 'react';

import type { AdfoxContextData } from '../../types';
import { PParams } from '../../../../../types';
import { calculatedParamsMiddleware, fetchTargets, mergeMiddlewares } from '@cian/adfox';

type Params = AdfoxContextData['params'];

let caughtPuds: Params | null = null;

/** Стабильное значение, которое инициализируется при первом вызове хука на клиенте. */
let cachedPrRandom: string | null = null;

export function getRandomId(): string {
  return String(Math.floor(Math.random() * 4294967295) + 1);
}

export function useAdfoxParams(pParams: PParams): Params | null {
  const [puids, setPuids] = useState<Params | null>(caughtPuds);
  const prRandomRef = useRef<string | null>(cachedPrRandom);

  useEffect(() => {
    if (!cachedPrRandom) {
      cachedPrRandom = getRandomId();
      prRandomRef.current = cachedPrRandom;
    }
  }, []);

  useEffect(() => {
    if (!caughtPuds) {
      mergeMiddlewares(
        calculatedParamsMiddleware(),
        fetchTargets('apps', {
          baseUrl: `//${window.__mainpage_api_host__ || window.location.host}/`,
          section_type: 1,
        }),
      ).then(puids => {
        caughtPuds = puids;

        setPuids(puids);
      });
    }
  }, []);

  return useMemo((): Params | null => {
    if (!puids) {
      return null;
    }

    return {
      pr: prRandomRef.current || '',
      ...puids,
      ...pParams,
    };
  }, [pParams, puids]);
}
